import HelpTooltip from '@/app/common/components/HelpTooltip';
import { guideTooltipHtml } from './CoverageHelpTip';

const HEAD_CHECK_GUIDE = {
  matchKey: 'head-check-200',
  title: 'تست ۲۰۰',
  paragraphs: [
    'این دکمه اول از مرورگر شما با HTTP HEAD آدرس‌ها را چک می‌کند؛ اگر CORS یا خطای شبکه مانع شود، همان URLها از سمت سرور میزفا دوباره بررسی می‌شوند.',
    'اگر برای آدرسی پاسخ ۴۰۴ (یا خطای مشابه) دیدید، آن URL را از لیست حذف کنید.',
    'این تست معیار دقیق آنچه ربات گوگل می‌بیند نیست و ارتباطی به درخواست ایندکس گوگل ندارد.',
  ],
};

export function HeadCheckHelpTip() {
  return (
    <HelpTooltip
      html={guideTooltipHtml(HEAD_CHECK_GUIDE)}
      placement="top"
      className="coverage-help-btn-inset"
    />
  );
}
